import { render, staticRenderFns } from "./m-page-loading.vue?vue&type=template&id=34f79481&scoped=true"
import script from "./m-page-loading.vue?vue&type=script&lang=js"
export * from "./m-page-loading.vue?vue&type=script&lang=js"
import style0 from "./m-page-loading.vue?vue&type=style&index=0&id=34f79481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f79481",
  null
  
)

export default component.exports